// This function allow to reference async chunks
__webpack_require__.k = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"5481":"d440848d373d56c01162"}[chunkId] + ".css";
};